import { type ButtonHTMLAttributes } from 'react'
import styles from './TableSortButton.module.css'

type TableSortButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export const TableSortButton = ({
  children,
  className,
  type = 'button',
  ...props
}: TableSortButtonProps) => (
  <button
    className={[styles.button, className].filter(Boolean).join(' ')}
    type={type}
    {...props}
  >
    {children}
  </button>
)
